import React from 'react';
import ReactDOM from 'react-dom';
import AdvisoryContent from './components/widgets/advisoryContent';
import StandAloneAdvisoryContent from './components/widgets/standAloneAdvisoryContent';


const advisoryContentElement = document.getElementById('advisoryContent');

// const app = document.getElementById('app');
// const { page } = app.dataset;

let app = document.getElementById('app');

let page = '';
if(app != '' && app != null && app != undefined) {
    page = app.dataset.page;  
} else {
    app = document.getElementById('appStandaloneHeader');
    page = app.dataset.page;  
}

if(page == 'standAloneHeader'){
   if (advisoryContentElement !== null) {
      ReactDOM.render(<StandAloneAdvisoryContent language={app.dataset?.language}/>, advisoryContentElement);
   }
}else{
   if (advisoryContentElement !== null) {
      ReactDOM.render(<AdvisoryContent />, advisoryContentElement);
   }
}
